var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyWsj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24805 3C8.66226 3 8.99805 3.33579 8.99805 3.75C8.99805 5.82115 10.677 7.50012 12.748 7.50012C13.1623 7.50012 13.498 7.83591 13.498 8.25012C13.498 8.66434 13.1623 9.00012 12.748 9.00012C9.84853 9.00012 7.49805 6.64954 7.49805 3.75C7.49805 3.33579 7.83383 3 8.24805 3Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24805 3C7.83383 3 7.49805 3.33579 7.49805 3.75C7.49805 5.82115 5.8191 7.50012 3.74805 7.50012C3.33383 7.50012 2.99805 7.83591 2.99805 8.25012C2.99805 8.66434 3.33383 9.00012 3.74805 9.00012C6.64756 9.00012 8.99805 6.64954 8.99805 3.75C8.99805 3.33579 8.66226 3 8.24805 3Z",
    fill: "#6F6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24805 13.499C7.83383 13.499 7.49805 13.1632 7.49805 12.749C7.49805 10.6779 5.8191 8.9989 3.74805 8.9989C3.33383 8.9989 2.99805 8.66311 2.99805 8.2489C2.99805 7.83469 3.33383 7.4989 3.74805 7.4989C6.64756 7.4989 8.99805 9.84948 8.99805 12.749C8.99805 13.1632 8.66226 13.499 8.24805 13.499Z",
    fill: "#6F6F6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24805 13.499C8.66226 13.499 8.99805 13.1632 8.99805 12.749C8.99805 10.6779 10.677 8.9989 12.748 8.9989C13.1623 8.9989 13.498 8.66312 13.498 8.2489C13.498 7.83469 13.1623 7.4989 12.748 7.4989C9.84853 7.4989 7.49805 9.84948 7.49805 12.749C7.49805 13.1632 7.83383 13.499 8.24805 13.499Z",
    fill: "#6F6F6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.25C12 7.83579 12.3358 7.5 12.75 7.5H21.75C22.1642 7.5 22.5 7.83579 22.5 8.25C22.5 8.66421 22.1642 9 21.75 9H12.75C12.3358 9 12 8.66421 12 8.25Z",
    fill: "#6F6F6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17.499C3 17.0848 3.33579 16.749 3.75 16.749H12C12.4142 16.749 12.75 17.0848 12.75 17.499C12.75 17.9132 12.4142 18.249 12 18.249H3.75C3.33579 18.249 3 17.9132 3 17.499Z",
    fill: "#6F6F6F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17.499C18 17.0848 18.3358 16.749 18.75 16.749L21.75 16.749C22.1642 16.749 22.5 17.0848 22.5 17.499C22.5 17.9132 22.1642 18.249 21.75 18.249L18.75 18.249C18.3358 18.249 18 17.9132 18 17.499Z",
    fill: "#6F6F6F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.999C13.7574 14.999 12.75 16.0064 12.75 17.249C12.75 18.4917 13.7574 19.499 15 19.499C16.2426 19.499 17.25 18.4917 17.25 17.249C17.25 16.0064 16.2426 14.999 15 14.999ZM11.25 17.249C11.25 15.178 12.9289 13.499 15 13.499C17.0711 13.499 18.75 15.178 18.75 17.249C18.75 19.3201 17.0711 20.999 15 20.999C12.9289 20.999 11.25 19.3201 11.25 17.249Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWsj);
export default __webpack_public_path__ + "static/media/MyWSJ.f202591dd0aa385fd2b9ab9349231435.svg";
export { ForwardRef as ReactComponent };